// constants for loading qr codes list
export const QR_LOAD_START = 'QR_LOAD_START';
export const QR_LOAD_FINISH = 'QR_LOAD_FINISH';
export const QR_LOAD_ERROR = 'QR_LOAD_ERROR';

//constants for update qr code
export const QR_UPDATE_START = 'QR_UPDATE_START';
export const QR_UPDATE_FINISH = 'QR_UPDATE_FINISH';
export const QR_UPDATE_ERROR = 'QR_UPDATE_ERROR';

//constants for delete qr code
export const QR_DELETE_START = 'QR_DELETE_START';
export const QR_DELETE_FINISH = 'QR_DELETE_FINISH';
export const QR_DELETE_ERROR = 'QR_DELETE_ERROR';

//constants for create qr code
export const QR_CREATE_START = 'QR_CREATE_START';
export const QR_CREATE_FINISH = 'QR_CREATE_FINISH';
export const QR_CREATE_ERROR = 'QR_CREATE_ERROR';

//constants for stat events
export const QR_STATS_START = 'QR_STATS_START';
export const QR_STATS_FINISH = 'QR_STATS_FINISH';
export const QR_STATS_ERROR = 'QR_STATS_ERROR';



// WEBPACK FOOTER //
// ./src/containers/qr/constants.js